export function useTheme() {
  const isDark = useState('theme-dark', () => true)

  function applyTheme(dark: boolean) {
    isDark.value = dark
    if (import.meta.client) {
      document.documentElement.classList.toggle('dark', dark)
    }
  }

  function initFromContext(nightModeEnabled: boolean, autoNightMode: boolean, startTime: string | null, endTime: string | null) {
    if (!autoNightMode) {
      applyTheme(nightModeEnabled)
      return
    }

    // Auto night mode: check current time against start/end
    const now = new Date()
    const currentMinutes = now.getHours() * 60 + now.getMinutes()

    const startMinutes = parseTimeToMinutes(startTime)
    const endMinutes = parseTimeToMinutes(endTime)

    if (startMinutes !== null && endMinutes !== null) {
      const isNight = startMinutes > endMinutes
        ? currentMinutes >= startMinutes || currentMinutes < endMinutes // overnight (e.g. 22:00 - 06:00)
        : currentMinutes >= startMinutes && currentMinutes < endMinutes // same day
      applyTheme(isNight)
    } else {
      applyTheme(nightModeEnabled)
    }
  }

  return { isDark: readonly(isDark), applyTheme, initFromContext }
}

function parseTimeToMinutes(time: string | null): number | null {
  if (!time) return null
  const parts = time.split(':')
  if (parts.length < 2) return null
  const h = parseInt(parts[0], 10)
  const m = parseInt(parts[1], 10)
  if (isNaN(h) || isNaN(m)) return null
  return h * 60 + m
}
